import logo from '../assets/images/AK.png';

export const Logo = () => {
    return (
        <img width={135} src={logo} alt="AK"/>
    );
};

export default Logo;
